var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatBody"},[_vm._l((_vm.messages),function(message,index){return _c('MessageTip',{key:message.id,attrs:{"index":index,"question":message.question,"answer":message.answer},on:{"personTypeChange":_vm.onPersonTypeChange}})}),(_vm.wsStatus === 'limit_exceeded')?_c('MessageLimit'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }